import { render, staticRenderFns } from "./desc.vue?vue&type=template&id=ad916822&"
import script from "./desc.vue?vue&type=script&lang=js&"
export * from "./desc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad916822')) {
      api.createRecord('ad916822', component.options)
    } else {
      api.reload('ad916822', component.options)
    }
    module.hot.accept("./desc.vue?vue&type=template&id=ad916822&", function () {
      api.rerender('ad916822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desc/desc.vue"
export default component.exports